import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';

import React, { useContext, useCallback } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Button } from 'ui-components/components/button';

import style from './style.module.less';
import { FilterEditorContext } from '../../context';
import messages from '../../messages';

const FilterRemover = ({ workingFilterId }) => {
  const { removeFilter } = useContext(FilterEditorContext);
  const intl = useIntl();
  const onRemoveFilter = useCallback(() => {
    removeFilter(workingFilterId);
  }, [removeFilter, workingFilterId]);

  return (
    <div className={style['filter-remover-wrap']}>
      <Button
        ariaLabel={intl.formatMessage(messages.removeFilter)}
        className={style['filter-remover']}
        onClick={onRemoveFilter}
        theme='unstyled'
      >
        <FontAwesomeIcon className={style.icon} icon={faTimes} />
      </Button>
    </div>
  );
};

FilterRemover.propTypes = {
  workingFilterId: PropTypes.string.isRequired,
};

export default FilterRemover;
